import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Subject } from "rxjs/Subject";
import 'rxjs/add/operator/map';
import { timeout } from "rxjs/operator/timeout";


@Injectable()
export class TopsectionsService {
    http: Http;

    topSectionsDataChange = new Subject<void>();
    topSections = [];
    private topSectionsData = [];

    constructor(http: Http) {
        this.http = http;
    }

    fetchSections(media) {
        this.http.get(`/api/sections/${media}`)
            .map((response: Response) => {
                const data = response.json();
                this.topSections = [
                    [
                        {
                            "topshort": data.short,
                            "topmid": data.mid,
                            "toptoday": data.today,
                            "active": data.active
                        }
                    ]
                ];
                return this.topSections;
            })
            .subscribe(
            (data) => {
                this.topSectionsData = data;
                setTimeout(() => this.topSectionsDataChange.next(), 1000 * 12);
            }
            );
    }
    fetchSectionsData() {
        // console.log(this.topSectionsData[0]);
        return this.topSectionsData[0];
    }

}


// WEBPACK FOOTER //
// /home/node/src/app/_services/topsections.service.ts